import * as React from "react";
import "flag-icons/css/flag-icons.min.css";
import { SearchableSelect } from "./SearchableSelect";
import { NATIONALITIES, DEFAULT_NATIONALITY, filterNationalities } from "../../../data/nationalities";
import { PLACEHOLDERS } from "../validation";

/**
 * Staatsangehörigkeit: suchbares Dropdown ALLER Nationalitäten (mit Flagge),
 * Default „Deutsch". Speichert das deutsche Adjektiv (z. B. „Deutsch"). Suche
 * matcht Adjektiv ODER Land. Freitext erlaubt.
 *
 * `autoDefault` (Default true): setzt bei leerem Wert automatisch „Deutsch" —
 * gewünscht in der Anlage. In der Detailansicht (bestehender Kontakt ohne
 * Angabe) MUSS es abgeschaltet werden (`autoDefault={false}`), sonst würde das
 * Feld beim Laden ungewollt „dirty" werden.
 */

const Flag: React.FC<{ code: string }> = ({ code }) => (
  <span
    className={`fi fi-${code.toLowerCase()}`}
    style={{ width: 18, height: 13, borderRadius: 2, flexShrink: 0, backgroundSize: "cover" }}
  />
);

export function NationalitySelect({
  label,
  name,
  value,
  onChange,
  required,
  autoDefault = true,
}: {
  label: string;
  name: string;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  autoDefault?: boolean;
}) {
  // Default „Deutsch" persistieren, falls leer — nur wenn autoDefault aktiv.
  React.useEffect(() => {
    if (autoDefault && !value) onChange(DEFAULT_NATIONALITY);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const effective = value || (autoDefault ? DEFAULT_NATIONALITY : "");
  const current = NATIONALITIES.find((n) => n.adjective === effective);

  return (
    <SearchableSelect
      label={label}
      name={name}
      value={effective}
      required={required}
      placeholder={PLACEHOLDERS.nationality}
      leftIcon={current ? <Flag code={current.code} /> : undefined}
      allowFreeText
      emptyText="Keine Nationalität gefunden"
      // Vollständige Liste zulassen — sonst kappt SearchableSelects Default (50)
      // die (ländersortierte) Liste bei „Gambisch".
      maxResults={NATIONALITIES.length}
      onChange={onChange}
      filter={(q) =>
        filterNationalities(q).map((n) => ({
          value: n.adjective,
          label: n.adjective,
          hint: n.country,
          icon: <Flag code={n.code} />,
        }))
      }
    />
  );
}

export default NationalitySelect;
